webpackJsonp([70144966829960],{

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/avcd.10d794a2.jpg";

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _contactModule = __webpack_require__(315);
	
	var _contactModule2 = _interopRequireDefault(_contactModule);
	
	var _avcd = __webpack_require__(496);
	
	var _avcd2 = _interopRequireDefault(_avcd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactPage = function (_Component) {
	  _inherits(ContactPage, _Component);
	
	  function ContactPage(props) {
	    _classCallCheck(this, ContactPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.handleInputChange = function (e) {
	      var _this$setState;
	
	      var name = e.target.name;
	      var value = e.target.value;
	      _this.setState((_this$setState = {}, _this$setState[name] = value, _this$setState));
	    };
	
	    _this.handleInputChange = _this.handleInputChange.bind(_this);
	    return _this;
	  }
	
	  ContactPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: _contactModule2.default.container },
	      _react2.default.createElement(
	        'h1',
	        { className: _contactModule2.default.title },
	        'Contact Us'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _contactModule2.default.tagline },
	        'Don\'t hesitate to reach out to us. We\'ll get back to you shortly!'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _contactModule2.default.logoWrapper },
	        _react2.default.createElement(
	          'form',
	          { className: _contactModule2.default.contactFlex,
	            method: 'POST',
	            action: 'https://formspree.io/cindys@avcd.com',
	            name: 'info-form'
	          },
	          _react2.default.createElement(
	            'label',
	            null,
	            '*Full Name'
	          ),
	          _react2.default.createElement('input', {
	            name: 'name',
	            type: 'text',
	            className: _contactModule2.default.contactInput,
	            required: true
	          }),
	          _react2.default.createElement(
	            'label',
	            null,
	            '*Email'
	          ),
	          _react2.default.createElement('input', {
	            name: 'email',
	            type: 'text',
	            className: _contactModule2.default.contactInput,
	            required: true
	          }),
	          _react2.default.createElement(
	            'label',
	            null,
	            'Phone'
	          ),
	          _react2.default.createElement('input', {
	            name: 'phone',
	            type: 'text',
	            className: _contactModule2.default.contactInput
	          }),
	          _react2.default.createElement(
	            'label',
	            null,
	            'Project Type:'
	          ),
	          _react2.default.createElement(
	            'select',
	            null,
	            _react2.default.createElement(
	              'option',
	              { value: 'none-selected' },
	              'Select One:'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'marine-newbuild' },
	              'Marine New Build'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'marine-refit' },
	              'Marine Refit'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'residential-new' },
	              'Residential New'
	            ),
	            _react2.default.createElement(
	              'option',
	              { value: 'residential-remodel' },
	              'Residential Remodel'
	            )
	          ),
	          _react2.default.createElement(
	            'label',
	            null,
	            'Desired Project Timing'
	          ),
	          _react2.default.createElement('input', {
	            name: 'timing',
	            type: 'text',
	            className: _contactModule2.default.contactInput
	          }),
	          _react2.default.createElement(
	            'label',
	            null,
	            'Comments'
	          ),
	          _react2.default.createElement('textarea', {
	            name: 'comments',
	            type: 'text',
	            rows: '5',
	            className: _contactModule2.default.contactInput
	          }),
	          _react2.default.createElement(
	            'p',
	            null,
	            '*Indicates required field'
	          ),
	          _react2.default.createElement(
	            'button',
	            { type: 'submit' },
	            'Submit'
	          )
	        ),
	        _react2.default.createElement('img', { src: _avcd2.default, className: _contactModule2.default.logo })
	      )
	    );
	  };
	
	  return ContactPage;
	}(_react.Component);
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ }),

/***/ 315:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-styles----contact-module---container---HgCNH","title":"src-styles----contact-module---title---2ALNL","contactInput":"src-styles----contact-module---contactInput---URLOC","contactFlex":"src-styles----contact-module---contactFlex---RnC7q","logoWrapper":"src-styles----contact-module---logoWrapper---1NXTz","logo":"src-styles----contact-module---logo---2-zRO","tagline":"src-styles----contact-module---tagline---1N7hX"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-e56cb6c9235df48be069.js